import { IIconProps } from "@/components/icons/interface";

const HpSendIcon = ({ width, height, color }: IIconProps) => {
  const fillColor = color ?? "var(--theme-combobox-icon-color, #1A1A1A)";
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M19.882 3.51553C19.8548 3.52279 16.1079 5.10827 11.5555 7.03934C4.99768 9.8212 3.26525 10.5586 3.21537 10.5931C3.01128 10.7309 2.94235 11.0121 3.05936 11.2334C3.09654 11.3033 3.17183 11.384 3.23623 11.423C3.2716 11.4439 4.37727 11.843 6.69382 12.6702C8.56684 13.3396 10.1015 13.8892 10.1052 13.8938C10.1088 13.8974 10.6575 15.4266 11.3242 17.2924C11.99 19.1582 12.5469 20.7074 12.5605 20.7346C12.5922 20.7999 12.6965 20.9042 12.7673 20.9414C12.9823 21.0539 13.2616 20.9895 13.3995 20.7963C13.4331 20.7491 14.097 19.1917 16.9487 12.4715C18.877 7.9246 20.4634 4.18129 20.4734 4.15408C20.497 4.08787 20.5043 3.97902 20.4907 3.90737C20.4371 3.63163 20.146 3.44478 19.882 3.51553ZM19.0539 4.94954C19.0521 4.95408 17.6997 8.14047 16.0498 12.0316C14.399 15.9228 13.0467 19.1101 13.043 19.1137C13.0394 19.1173 12.5959 17.8847 12.0562 16.3745L11.0748 13.628L12.7464 11.9545C14.312 10.3881 14.4208 10.2774 14.4462 10.2221C14.4825 10.1459 14.4961 10.0833 14.4961 9.99988C14.4961 9.85748 14.4526 9.75317 14.3492 9.65068C14.1931 9.49376 13.9809 9.45839 13.7777 9.55363C13.7224 9.57902 13.6117 9.68787 12.0453 11.2525L10.3718 12.9241L7.62444 11.9427C5.81763 11.2978 4.88158 10.9595 4.88974 10.9541C4.90516 10.945 19.0403 4.94592 19.0503 4.9441C19.0548 4.9432 19.0557 4.94592 19.0539 4.94954Z"
        fill={fillColor}
      />
    </svg>
  );
};

export { HpSendIcon };
